export default {
    // Header Section
    "discover_your": "जानें अपना",
    "nakshatra": "नक्षत्र",
    "birth_star_analysis": "जन्म नक्षत्र विश्लेषण",
    "nakshatra_description": `नक्षत्र चंद्रमा के पथ के साथ 27 खगोलीय खंडों में से एक है, जिनमें से प्रत्येक को चार पादों (भागों) में विभाजित किया गया है। प्रत्येक पाद विशेष अक्षरों से जुड़ा होता है, जो अक्सर नवजात शिशु के नामकरण के लिए चंद्रमा की स्थिति के आधार पर चुने जाते हैं।`,

    // Service Information
    "enter_birth_details": "अपनी जन्म विवरण दर्ज करें",
    "complete_nakshatra_analysis": "पूर्ण नक्षत्र विश्लेषण",
    "service_price": "सेवा मूल्य",
    "comprehensive_nakshatra_analysis_note": "आपके जन्म नक्षत्र के व्यक्तित्व, संबंधों और जीवन पथ पर प्रभाव का गहन अध्ययन",

    // Form Fields
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "email_address": "ईमेल पता",
    "enter_email_address": "अपना ईमेल पता दर्ज करें",
    "phone_number": "फ़ोन नंबर",
    "enter_phone_number": "अपना फ़ोन नंबर दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "महिला",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "time_of_birth": "जन्म समय",
    "exact_time_critical_for_nakshatra": "सटीक जन्म समय नक्षत्र की सही पहचान के लिए आवश्यक है",
    "place_of_birth": "जन्म स्थान",
    "place_of_birth_placeholder": "शहर, राज्य, देश",
    "preferred_language": "पसंदीदा भाषा",
    "english": "अंग्रेज़ी",
    "hindi": "हिंदी",
    "telugu": "तेलुगु",
    "kannada": "कन्नड़",
    "language_note": "आपका नक्षत्र विश्लेषण चयनित भाषा में दिया जाएगा",

    // Core Nakshatra Features
    "birth_star_identification": "जन्म नक्षत्र की पहचान",
    "personality_traits_detailed": "विस्तृत व्यक्तित्व और चरित्र विश्लेषण",
    "compatibility_analysis": "विवाह और संबंध अनुकूलता",
    "career_guidance_nakshatra": "जन्म नक्षत्र के आधार पर करियर मार्गदर्शन",
    "lucky_elements": "शुभ रंग, अंक और रत्न",
    "pdf_download": "व्यापक पीडीएफ रिपोर्ट",

    "what_you_get": "आपके नक्षत्र विश्लेषण में क्या शामिल है",
    "your_birth_star_detailed": "आपका जन्म नक्षत्र विस्तार से",
    "nakshatra_characteristics": "मुख्य नक्षत्र विशेषताएं",
    "pada_analysis": "पाद (चतुर्थांश) विश्लेषण",
    "ruling_deity_insights": "स्वामी देवता और आध्यात्मिक दृष्टिकोण",

    // Actions & Buttons
    "pay_and_generate_analysis": "मेरा नक्षत्र विश्लेषण प्राप्त करें",
    "processing_payment": "भुगतान संसाधित हो रहा है",
    "processing_request": "विश्लेषण तैयार हो रहा है",

    // Payment & Success Messages
    "thank_you": "धन्यवाद",
    "payment_successful": "भुगतान सफल!",
    "nakshatra_analysis_processing": "हमारे विशेषज्ञ वैदिक ज्योतिषी आपका नक्षत्र विश्लेषण तैयार कर रहे हैं। आपको अपने जन्म नक्षत्र के प्रभाव पर गहन जानकारी प्राप्त होगी।",
    "order_id": "ऑर्डर आईडी",
    "payment_id": "भुगतान आईडी",
    "amount_paid": "भुगतान राशि",

    // Delivery Information
    "delivery_information": "डिलीवरी जानकारी",
    "delivery_time": "विश्लेषण डिलीवरी",
    "within_12_hours_delivery_note": "आपकी विस्तृत नक्षत्र रिपोर्ट 12 घंटों में तैयार होगी",
    "whatsapp_notification": "व्हाट्सऐप अपडेट",
    "whatsapp_delivery_note": "व्हाट्सऐप पर तुरंत सूचनाएं प्राप्त करें",
    "email_delivery": "ईमेल डिलीवरी",
    "email_delivery_note": "पूर्ण विश्लेषण भेजा जाएगा",

    // What You'll Receive
    "what_youll_receive": "आपका नक्षत्र विश्लेषण पैकेज",
    "detailed_nakshatra_report": "विस्तृत नक्षत्र रिपोर्ट (पीडीएफ)",
    "birth_star_characteristics": "जन्म नक्षत्र व्यक्तित्व प्रोफ़ाइल",
    "pada_and_symbol_analysis": "पाद विश्लेषण और पवित्र प्रतीक",
    "compatibility_insights": "विवाह और साझेदारी अनुकूलता",
    "lucky_colors_numbers": "शुभ तत्व और अनुशंसित रत्न",

    // Visual Content
    "sample_nakshatra_analysis": "नमूना नक्षत्र विश्लेषण",
    "sample_nakshatra_description": "आपके व्यक्तिगत जन्म नक्षत्र विश्लेषण का पूर्वावलोकन विस्तृत अंतर्दृष्टियों के साथ",
    "popular_nakshatras": "27 नक्षत्र",

    // Major Nakshatra Names
    "ashwini": "अश्विनी - अश्वारोही",
    "bharani": "भरणी - धारक",
    "kritika": "कृतिका - काटने वाला",
    "rohini": "रोहिणी - लालिमा वाली",
    "mrigashira": "मृगशिरा - मृग के सिर वाली",
    "ardra": "आर्द्रा - आर्द्र",
    "punarvasu": "पुनर्वसु - पुनः प्रकाश",
    "pushya": "पुष्य - पोषक",
    "ashlesha": "आश्लेषा - आलिंगन करने वाली",
    "magha": "मघा - महान",
    "purva_phalguni": "पूर्वा फाल्गुनी",
    "uttara_phalguni": "उत्तर फाल्गुनी",

    // Status & Processing
    "your_nakshatra_analysis_status": "आपके नक्षत्र विश्लेषण की स्थिति",
    "processing_your_analysis": "आपके जन्म नक्षत्र का विश्लेषण हो रहा है",
    "analysis_processing_message": "हमारे वैदिक ज्योतिष विशेषज्ञ आपके नक्षत्र के प्रभावों का अध्ययन कर रहे हैं और आपकी व्यक्तिगत अंतर्दृष्टियाँ तैयार कर रहे हैं।",
    "request_id": "विश्लेषण आईडी",
    "status": "स्थिति",
    "processing": "प्रगति पर",
    "pending": "प्रतीक्षा में",
    "email_notification_sent": "पुष्टिकरण ईमेल भेजा गया",
    "whatsapp_update_coming": "व्हाट्सऐप अपडेट सक्षम",
    "delivery_within_12_hours": "रिपोर्ट 12 घंटों में तैयार",

    // Support & Contact
    "contact_support": "ज्योतिष सहायता से संपर्क करें",
    "need_help": "मार्गदर्शन चाहिए?",
    "contact_us_at": "हमसे यहां संपर्क करें",

    // Error Messages
    "please_fill_all_required_fields": "कृपया सभी आवश्यक जन्म विवरण भरें",
    "payment_failed": "भुगतान असफल। कृपया पुनः प्रयास करें।",
    "processing_failed": "विश्लेषण विफल हुआ। हमारी सहायता टीम से संपर्क करें।",

    // Nakshatra-Specific Elements
    "birth_star": "जन्म नक्षत्र",
    "nakshatra_lord": "नक्षत्र स्वामी",
    "ruling_planet": "शासक ग्रह",
    "nakshatra_symbol": "पवित्र प्रतीक",
    "presiding_deity": "अधिष्ठाता देवता",
    "gana_type": "गण वर्गीकरण",
    "nakshatra_nature": "स्वभाव",
    "power_animal": "शक्ति पशु",

    // Pada (Quarters) Analysis
    "pada_1": "प्रथम पाद (0°-3°20')",
    "pada_2": "द्वितीय पाद (3°20'-6°40')",
    "pada_3": "तृतीय पाद (6°40'-10°)",
    "pada_4": "चतुर्थ पाद (10°-13°20')",
    "your_pada": "आपका नक्षत्र पाद",
    "pada_characteristics": "पाद विशेषताएं",
    "pada_influence": "आपके पाद का आप पर प्रभाव",

    // Personality & Character
    "core_personality": "मुख्य व्यक्तित्व गुण",
    "strengths_weaknesses": "ताकत और सुधार के क्षेत्र",
    "mental_nature": "मानसिक प्रवृत्ति",
    "emotional_patterns": "भावनात्मक पैटर्न",
    "behavioral_tendencies": "व्यवहारिक प्रवृत्तियां",
    "life_approach": "जीवन के प्रति दृष्टिकोण",

    // Compatibility & Relationships
    "compatible_nakshatras": "सबसे अनुकूल नक्षत्र",
    "challenging_nakshatras": "संभावित चुनौतीपूर्ण नक्षत्र",
    "marriage_compatibility": "विवाह और साझेदारी विश्लेषण",
    "friendship_compatibility": "मित्रता सामंजस्य",
    "business_partnership": "व्यावसायिक साझेदारी की संभावना",
    "relationship_advice": "संबंध मार्गदर्शन",

    // Career & Profession
    "suitable_careers": "उपयुक्त करियर पथ",
    "professional_strengths": "व्यावसायिक ताकतें",
    "work_environment": "उत्तम कार्य वातावरण",
    "leadership_style": "नेतृत्व शैली",
    "business_prospects": "उद्यमिता की संभावना",
    "financial_tendencies": "धन प्रबंधन शैली",

    // Health & Wellness
    "health_tendencies": "स्वास्थ्य प्रवृत्तियां",
    "vulnerable_areas": "ध्यान देने योग्य क्षेत्र",
    "wellness_recommendations": "स्वास्थ्य और तंदुरुस्ती सुझाव",
    "dietary_guidance": "आहार संबंधी अनुशंसाएं",

    // Spiritual & Remedial
    "spiritual_path": "आध्यात्मिक यात्रा",
    "life_purpose": "जीवन का उद्देश्य",
    "karmic_lessons": "जीवन के पाठ",
    "recommended_remedies": "वैदिक उपाय",
    "mantras_to_chant": "अनुशंसित मंत्र",
    "meditation_practices": "ध्यान तकनीकें",
    "worship_recommendations": "पूजा संबंधी मार्गदर्शन",
    "fasting_days": "शुभ व्रत के दिन",
    "donation_suggestions": "दान संबंधी सुझाव",

    // Lucky Elements
    "lucky_colors": "शुभ रंग",
    "lucky_numbers": "शुभ अंक",
    "lucky_days": "शुभ दिन",
    "lucky_directions": "शुभ दिशा",
    "lucky_gemstones": "शुभ रत्न",
    "lucky_metals": "शुभ धातु",
    "favorable_timing": "महत्वपूर्ण कार्यों का शुभ समय",

    // Detailed Analysis Sections
    "nakshatra_mythology": "नक्षत्र पौराणिक पृष्ठभूमि",
    "cosmic_connection": "खगोलीय महत्व",
    "elemental_influence": "तत्वीय प्रभाव",
    "seasonal_connection": "ऋतु संबंध",
    "lunar_mansion": "चंद्र महल का महत्व",
    "vedic_wisdom": "प्राचीन वैदिक ज्ञान"
};
